import { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes} from '@angular/router';
import { AppComponent } from "./app.component";
import { CaseSearchComponent } from './case-search/casesearch.component';
import { CaseDetailsComponent } from './case-details/casedetails.component';

const appRoutes: Routes = [  
    {
        path: 'support/case-lookup',
        children: [
            {
                path: '',
                component: CaseSearchComponent
            },
            {             
                path: 'case-details',
               component: CaseDetailsComponent
            }
        ]
    }
];

@NgModule({    
    imports: [
        RouterModule.forRoot(appRoutes, { enableTracing: true })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/app.routing.ts